import React from 'react';
import './ImageGallery.styles.scss';
import axios from 'axios';
import JSZip from 'jszip'; // Import JSZip
import {saveAs} from 'file-saver'; // Import FileSaver

const ImageGallery = ({images, setLoading, loading}) => {
  const handleDownloadImage = async (url) => {
    setLoading(true);
    try {
      const response = await axios.get(url, {responseType: 'blob'});

      // Create a Blob from the response and get a URL for the blob
      const blob = new Blob([response.data], {type: response.data.type});
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = getFileNameFromUrl(url);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl); // Clean up
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error downloading the image:', error);
    }
  };
  const copyLink = (url) => {
    navigator.clipboard.writeText(url);
  };

  const handleDownloadAll = async () => {
    const zip = new JSZip();
    const imgFolder = zip.folder('extracted-images'); // Optional: creates a folder inside the zip
    setLoading(true);
    try {
      // Fetch all images and add them to the zip
      const imagePromises = images.map(async (url, index) => {
        const filename = getFileNameFromUrl(url, index);
        const response = await axios.get(url, {responseType: 'blob'});
        imgFolder.file(filename, response.data);
      });

      // Wait for all images to be added to the zip
      await Promise.all(imagePromises);

      // Generate the zip file and trigger the download
      const content = await zip.generateAsync({type: 'blob'});
      saveAs(content, 'images.zip');
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error downloading all images:', error);
    }
  };

  // Helper function to extract the file name from the URL
  const getFileNameFromUrl = (url, index = null) => {
    const urlParts = url.split('/');
    let filename = urlParts[urlParts.length - 1].split('?')[0];

    // If filename is invalid, create a default one
    if (!filename || filename.length === 0) {
      const extension = url.split('.').pop().split(/#|\?/)[0];
      filename = `image_${index + 1}.${extension}`;
    }

    return filename;
  };

  return (
    <>
      <div className="image-gallery">
        <div className="gallery-header">
          <h3>Extracted Images</h3>
          <button className={`download-all-button ${loading ? 'element-disabled' : ''}`} disabled={loading} onClick={handleDownloadAll}>
            Download All Images
          </button>
        </div>
        <div className="image-grid">
          {images.map((url, index) => (
            <div className="card" key={index}>
              <div className="image-container">
                <img alt={`Extracted Image${index + 1}`} src={url} loading="lazy" />
              </div>
              <div className="button-container">
                <div className="file-type">
                  <p className="file-type-tag">{url.split('.').pop().toUpperCase()}</p>
                </div>
                <div>
                  <svg
                    className={`svg-icon ${loading ? 'svg-disabled' : ''}`}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    disabled={loading}
                    onClick={() => copyLink(url)}
                  >
                    {' '}
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <path d="M9 15l6 -6"></path> <path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464"></path>{' '}
                    <path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463"></path>{' '}
                  </svg>

                  <svg
                    className={`svg-icon ${loading ? 'svg-disabled' : ''}`}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    disabled={loading}
                    onClick={() => handleDownloadImage(url)}
                  >
                    {' '}
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path> <path d="M7 11l5 5l5 -5"></path> <path d="M12 4l0 12"></path>{' '}
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ImageGallery;
